var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Map"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 326",
    d: "M26.8125 21.0344V8.29062C26.8125 7.95609 26.4605 7.73852 26.1613 7.88812L21.4691 10.2342C21.3684 10.2846 21.2524 10.2953 21.1442 10.2644L11.8558 7.61059C11.7476 7.57966 11.6316 7.59043 11.5309 7.64078L6.43625 10.1881C6.2838 10.2643 6.1875 10.4202 6.1875 10.5906V23.3344C6.1875 23.6689 6.53954 23.8865 6.83875 23.7369L11.5309 21.3908C11.6316 21.3404 11.7476 21.3297 11.8558 21.3606L21.1442 24.0144C21.2524 24.0453 21.3684 24.0346 21.4691 23.9842L26.5637 21.4369C26.7162 21.3607 26.8125 21.2048 26.8125 21.0344Z",
    stroke: "#02A0FC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 327",
    d: "M21.3125 24.0625V10.3125",
    stroke: "#02A0FC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 328",
    d: "M11.6875 21.3125V7.5625",
    stroke: "#02A0FC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/Map.7831c531482ae54faed1402a502e75b1.svg";
export { ForwardRef as ReactComponent };